import "./BackCover.css"

export default function BackCover () {
    return (
        <div className="back-cover">
            Made by Du Hoang
            <div>www.createastory.site</div>
        </div>
    )
}